// Página AdminSettings - Página principal de configuraciones
// Permite acceder a diferentes configuraciones del sistema

import { Link } from 'react-router-dom'
import Card from '../../components/Card'
import './AdminSettings.css'

/**
 * Página AdminSettings
 * Panel principal de configuraciones del sistema
 */
function AdminSettings() {
  // Opciones de configuración disponibles
  const settingsOptions = [
    {
      title: 'Categorías',
      description: 'Gestiona las categorías de productos disponibles en el catálogo',
      icon: '📁',
      path: '/admin/configuraciones/categorias',
      color: '#4a90e2'
    },
    {
      title: 'Subcategorías',
      description: 'Gestiona las subcategorías asociadas a cada categoría',
      icon: '📂',
      path: '/admin/configuraciones/subcategorias',
      color: '#50c878'
    },
    {
      title: 'Envío',
      description: 'Configura las reglas de envío gratis y costos de envío',
      icon: '🚚',
      path: '/admin/configuraciones/envio',
      color: '#e67e22'
    },
    {
      title: 'Ganancia General',
      description: 'Configura el porcentaje de ganancia por defecto para categorías sin porcentaje específico',
      icon: '💰',
      path: '/admin/configuraciones/ganancia',
      color: '#27ae60'
    },
    {
      title: 'Alertas',
      description: 'Configura las condiciones y umbrales para las alertas del sistema',
      icon: '🚨',
      path: '/admin/configuraciones/alertas',
      color: '#e74c3c'
    },
    {
      title: 'Configuración de Ayuda',
      description: 'Gestiona el contenido de la página de ayuda pública (FAQs, envíos, devoluciones, etc.)',
      icon: '❓',
      path: '/admin/configuraciones/ayuda',
      color: '#3498db'
    },
    {
      title: 'Configuración de Página de Inicio',
      description: 'Gestiona la imagen de fondo, colores y contenido del Hero (sección principal)',
      icon: '🏠',
      path: '/admin/configuraciones/inicio',
      color: '#d4a574'
    },
    {
      title: 'Configuración Comercial',
      description: 'Selecciona el rubro activo y el diseño de la tienda pública',
      icon: '🛍️',
      path: '/admin/configuraciones/comercial',
      color: '#2c3e50'
    },
    {
      title: 'Reglas de Negocio',
      description: 'Configura reglas comerciales (stock, pedidos/ventas y medios de pago)',
      icon: '⚖️',
      path: '/admin/configuraciones/reglas-negocio',
      color: '#8e44ad'
    },
    {
      title: 'Notificaciones',
      description: 'Configura email/WhatsApp y plantillas transaccionales',
      icon: '🔔',
      path: '/admin/configuraciones/notificaciones',
      color: '#0ea5e9'
    },
    {
      title: 'Auditoría y Logs',
      description: 'Configura el registro de eventos y revisa el historial de auditoría',
      icon: '🧾',
      path: '/admin/configuraciones/auditoria',
      color: '#9b59b6'
    },
    {
      title: 'Manejo de Datos',
      description: 'Herramientas para limpieza de tablas, respaldo y restauración de datos',
      icon: '💾',
      path: '/admin/configuraciones/datos',
      color: '#607d8b'
    }
    // Más opciones de configuración se pueden agregar aquí
    // {
    //   title: 'Configuración General',
    //   description: 'Ajustes generales del sistema',
    //   icon: '⚙️',
    //   path: '/admin/configuraciones/general',
    //   color: '#9b59b6'
    // }
  ]

  return (
    <div className="admin-settings-page">
      <div className="settings-header">
        <h2>Configuraciones del Sistema</h2>
        <p className="settings-description">
          Gestiona las configuraciones y opciones disponibles en el sistema
        </p>
      </div>

      <div className="settings-grid">
        {settingsOptions.map((option, index) => (
          <Link key={index} to={option.path} className="settings-card-link">
            <Card variant="default" className="settings-card">
              <div className="settings-card-content">
                <div 
                  className="settings-icon" 
                  style={{ backgroundColor: `${option.color}20`, color: option.color }}
                >
                  {option.icon}
                </div>
                <div className="settings-card-info">
                  <h3>{option.title}</h3>
                  <p>{option.description}</p>
                </div>
                <div className="settings-card-arrow">→</div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default AdminSettings

